import InfoValueRow from '@shared/components/InfoValueRow';
import HorizontalSeparator from '@shared/pages/Flights/components/HorizontalSeparator';

const FlightPaymentDetails = ({ total, isInUSD = false }) => {
  return (
    <>
      <HorizontalSeparator color="#E5E5E5" />

      <InfoValueRow
        label="Total"
        value={total}
        isPrice
        boldLeft
        boldRight
        color="red"
        fontSize={{ xs: '17px', md: '18px', lg: '15px', xl: '17px' }}
        isInUSD={isInUSD}
      />
    </>
  );
};

export default FlightPaymentDetails;
